// src/features/projects/components/ProjectTechnologies.tsx

import React from 'react';
import styles from './ProjectTechnologies.module.scss';
import { Technology } from '../types/project';
import StarBorder from './StarBorder';

interface ProjectTechnologiesProps {
  technologies: Technology[];
}

const ProjectTechnologies: React.FC<ProjectTechnologiesProps> = ({ technologies }) => {

  if (!technologies || technologies.length === 0) return null;

  return (
    <section className={styles.technologiesSection}>

      <div className={styles.techList}>
        {technologies.map((tech, index) => (
          <StarBorder
            key={index}
            className={styles.techBadge}
            color="rgba(255, 255, 255, 0.15)" 
            /* or a brand color if you want a more colorful star border */
            speed="8s"
          >
            {tech.name}
          </StarBorder>
        ))}
      </div>
    </section>
  );
};

export default ProjectTechnologies;